"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const react_syntax_highlighter_1 = require("react-syntax-highlighter");
const prism_1 = require("react-syntax-highlighter/dist/esm/styles/prism");
const config_1 = require("../config");
const RuleTable_1 = require("./components/RuleTable");
const utils_1 = require("./utils");
//@ts-ignore
const README_zh_CN_md_1 = __importDefault(require("../README.zh-CN.md"));
const App = () => {
    const query = (0, utils_1.getQuery)();
    const [namespace, setNamespace] = (0, react_1.useState)((0, utils_1.defaultTo)('quik-start', 'quik-start', config_1.NAMESPACES));
    const [hideOff, toggleHideOff] = (0, react_1.useState)(query.hideOff === '1');
    const language = (0, utils_1.getLanguage)();
    (0, react_1.useEffect)(() => {
        document.documentElement.lang = language;
    }, []);
    const Header = (react_1.default.createElement("header", { className: 'header' },
        react_1.default.createElement("div", { className: 'header-container' },
            react_1.default.createElement("a", { className: 'header-title', onClick: () => {
                    setNamespace('quik-start');
                    (0, utils_1.replaceUrl)((0, utils_1.newUrl)({ query: { rule: 'quik-start' } }));
                } },
                react_1.default.createElement("svg", { className: "eslint-icon", viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "4179", width: "200", height: "200" },
                    react_1.default.createElement("path", { d: "M332.72493 412.535453l171.001167-98.72725a13.830826 13.830826 0 0 1 13.83424 0l171.007994 98.72725a13.841066 13.841066 0 0 1 6.915413 11.9808v197.4545a13.858133 13.858133 0 0 1-6.918826 11.980799l-171.004581 98.72725a13.830826 13.830826 0 0 1-13.83424 0l-171.001167-98.72725a13.841066 13.841066 0 0 1-6.915413-11.980799V424.516253a13.847893 13.847893 0 0 1 6.915413-11.9808", fill: "#7986CB", "p-id": "4180" }),
                    react_1.default.createElement("path", { d: "M955.265709 502.476783L750.950409 147.036155c-7.420586-12.8512-21.128533-22.330026-35.969705-22.330026H306.329624c-14.844586 0-28.555946 9.478826-35.976532 22.330026L66.037792 501.701957c-7.420586 12.854613-7.420586 29.081599 0 41.932798L270.353092 896.170637c7.420586 12.8512 21.131946 19.421866 35.976532 19.421866h408.65108c14.83776 0 28.552532-6.372693 35.969705-19.227306l204.3153-353.109322c7.427413-12.847786 7.427413-27.921066 0-40.768852m-169.181861 170.922661c0 5.2224-3.14368 10.059093-7.676586 12.673706l-260.249592 150.152529a14.80704 14.80704 0 0 1-14.725119 0l-260.450978-150.152529c-4.52608-2.614613-7.693653-7.44448-7.693653-12.673706v-300.30847c0-5.229226 3.119787-10.059093 7.649279-12.677119l260.242765-150.152529a14.779733 14.779733 0 0 1 14.71488 0l260.471458 150.152529c4.529493 2.618027 7.717546 7.447893 7.717546 12.677119z", fill: "#3F51B5", "p-id": "4181" })),
                react_1.default.createElement("span", null, "Eslint \u4EE3\u7801\u89C4\u8303\u8BF4\u660E")),
            react_1.default.createElement("nav", { className: 'header-nav' }, config_1.NAMESPACES.map((namespace) => (react_1.default.createElement("a", { className: 'nav-item', key: namespace, onClick: () => {
                    setNamespace(namespace);
                    (0, utils_1.replaceUrl)((0, utils_1.newUrl)({ query: { rule: namespace } }));
                } }, namespace)))))));
    const Banner = namespace.includes('quik-start')
        ? null
        : (react_1.default.createElement("div", { className: "container-fluid top-gap-big" },
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { type: "checkbox", checked: hideOff, onChange: (e) => {
                        toggleHideOff(e.target.checked);
                        (0, utils_1.replaceUrl)((0, utils_1.newUrl)({ query: { hideOff: e.target.checked } }));
                    } }),
                (0, utils_1.t)('隐藏已禁用的规则'))));
    const QuikStart = () => {
        return (react_1.default.createElement(react_markdown_1.default, { children: README_zh_CN_md_1.default, components: {
                code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || '');
                    return !inline && match ? (react_1.default.createElement(react_syntax_highlighter_1.Prism, { children: String(children).replace(/\n$/, ''), style: prism_1.cb, language: match[1], PreTag: "div", ...props })) : (react_1.default.createElement("code", { className: className, ...props }, children));
                }
            } }));
    };
    return namespace.includes('quik-start')
        ? (react_1.default.createElement(react_1.default.Fragment, null,
            Header,
            Banner,
            react_1.default.createElement("div", { style: {
                    margin: '0 auto'
                }, className: 'container' },
                react_1.default.createElement(QuikStart, null))))
        : (react_1.default.createElement(react_1.default.Fragment, null,
            Header,
            Banner,
            react_1.default.createElement(RuleTable_1.RuleTable, { namespace: namespace, hideOff: hideOff })));
};
exports.default = App;
